import { Component, Inject, OnInit, EventEmitter, Output, ViewEncapsulation } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { FormGroup, FormBuilder } from '@angular/forms';
import { COMMA, ENTER, TAB } from '@angular/cdk/keycodes';
import { SaveService } from '../../../services/save.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { MatChipInputEvent } from "@angular/material/chips";

@Component({
    selector: "customerdocument-filter",
    templateUrl: './customerdocument-filter.component.html',
    styleUrls: ['../../../style/form.component.less', './customerdocument-filter.component.less', '../../../style/expand-collapse-panel.component.less'],
    standalone: false,
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
            state('expanded', style({ height: '*', })),
            transition('expanded => collapsed', [animate('0ms cubic-bezier(0.4, 0.0, 0.2, 1)')]),
        ]),
    ],
    encapsulation: ViewEncapsulation.None
})

export class CustomerDocumentFilterComponent implements OnInit {

    form!: FormGroup;
    @Output() outputFilter = new EventEmitter<CustomerDocumentFilter>();

    visible = true;
    selectable = true;
    removable = true;
    addOnBlur = true;
    readonly separatorKeysCodes: number[] = [COMMA, TAB, ENTER];

    documentIds: string[] = [];
    documentTypes: string[] = [];
    customerIds: string[] = [];
    contractNumbers: string[] = [];
    unitIds: string[] = [];

    constructor(
        private http: HttpClient
        , private fb: FormBuilder
        , @Inject('BASE_URL') private baseUrl: string
        , private saveService: SaveService
    ) {
    }

    ngOnInit() {
        this.saveService.addListener(this);
        this.createForm();
    }

    createForm() {
        this.form = this.fb.group({
        });
    }

    changeTypeButton() {
        return this.documentIds.length < 1 && this.documentTypes.length < 1 && this.customerIds.length < 1
            && this.contractNumbers.length < 1 && this.unitIds.length < 1;
    }

    applyFilter(event: MatChipInputEvent, list: string): void {
        //MatChipInputEvent input is being deprecated, for migration might be changed to inputElement event.input ==> event.inputElement
        const input = event.input;
        const value = event.value;
        if ((value || '').trim()) {
            switch (list) {
                case 'documentids':
                    this.documentIds.push(value.replace('+', '').trim());
                    break;
                case 'documenttypes':
                    this.documentTypes.push(value.replace('+', '').trim());
                    break;
                case 'customerids':
                    this.customerIds.push(value.replace('+', '').trim());
                    break;
                case 'contractnumbers':
                    this.contractNumbers.push(value.replace('+', '').trim());
                    break;
                case 'unitids':
                    this.unitIds.push(value.replace('+', '').trim());
                    break;
            }
        }
        // Reset the input value
        if (input) {
            input.value = '';
        }
    }

    remove(value: string, list: string): void {
        let index = -1;
        switch (list) {
            case 'documentids':
                index = this.documentIds.indexOf(value);
                if (index >= 0) {
                    this.documentIds.splice(index, 1);
                }
                break;
            case 'documenttypes':
                index = this.documentTypes.indexOf(value);
                if (index >= 0) {
                    this.documentTypes.splice(index, 1);
                }
                break;
            case 'customerids':
                index = this.customerIds.indexOf(value);
                if (index >= 0) {
                    this.customerIds.splice(index, 1);
                }
                break;
            case 'contractnumbers':
                index = this.contractNumbers.indexOf(value);
                if (index >= 0) {
                    this.contractNumbers.splice(index, 1);
                }
                break;
            case 'unitids':
                index = this.unitIds.indexOf(value);
                if (index >= 0) {
                    this.unitIds.splice(index, 1);
                }
                break;
        }
    }

    onFilter() {
        this.outputFilter.emit({
            'DocumentIds': this.documentIds,
            'CustomerIds': this.customerIds,
            'ContractNumbers': this.contractNumbers,
            'UnitIds': this.unitIds,
            'DocumentTypes': this.documentTypes
        });
    }
}